import './Pet.css';
import PetModal from '../petModal/PetModal';
import { useState } from 'react';

import {
  iconURLForRarityId,
  imageURLForAsset,
  iconURLForSpecialty,
  iconURLForBonusType
  } from '../../assetHelpers';

const Pet = (props) => {

  const [activeModals, setActiveModals] = useState({}); // add modals as a key/value, where the key is a unique id used to dismiss the modal and the value is what to render

  const { pet } = props;

  if (!pet) {
    return null;
  }

  const showPetModal = () => {
    const modalId = "petPetModal";
    const activeModalsToUpdate = activeModals;

    const onDismiss = () => {
      const activeModalsToEdit = activeModals;
      delete activeModalsToEdit[modalId];
      setActiveModals({...activeModalsToEdit}); // use spread operator to create a new object
    };

    activeModalsToUpdate[modalId] = <PetModal
      pet={pet}
      onDismiss={onDismiss}
      parentComponentExtendedContent={props.parentComponentExtendedContent}
    />
    setActiveModals({...activeModalsToUpdate});
  }

  return (
    <>
      <div className="petSummaryDetails">
        {Object.keys(activeModals).map( (modalId) => {
          return activeModals[modalId]
        })}
        <div className="image">
          <img src={imageURLForAsset(pet.hasOwnProperty("visualId") ? pet.visualId.toLowerCase() : "placeholder")}/>
        </div>
        <h3 className="title">
          {pet.hasOwnProperty("name") ? pet.name : "Unknown"}
        </h3>
        {pet && pet.specialty ?
          <div className="specialties">
            Specialty:
              <img src={iconURLForSpecialty(pet.specialty)} />
          </div>
        :
          null
        }
        {pet && pet.bonus ?
          <div className="bonusType">
          Bonus:
            <img src={iconURLForBonusType(pet.bonus.type)} />
          </div>
        :
        null
        }
        {pet.hasOwnProperty("rarity") ?
          <div className="availability">
            Rarity: <img src={iconURLForRarityId(pet.rarity)} className="rarityStars" />
          </div>
        :
          <div className="availability">
            Rarity: ?
          </div>
        }
        {pet.hasOwnProperty("level") ?
          <div className="description">
            Level: {pet.level}
          </div>
        :
          null
        }
        <button className="petButtonOverlay" onClick={showPetModal}></button>
      </div>
      {props.parentComponentExtendedContent}
    </>

  );
}

export default Pet;